module.exports = __webpack_public_path__ + "static/media/marker.4c0482e5.svg";